module.exports = __webpack_public_path__ + "static/logo-transparent-fad2a25cfb0c324eec26dd5da7979b47.png";